import { createAsyncThunk } from '@reduxjs/toolkit';
import * as api from '../../api/liveChatSenderApi';

export const getLiveChatSender = createAsyncThunk(
  'LiveChatSender/getLiveChatSender',
  async (userId, thunkAPI) => {
    try {
      return await api.getLiveChatSender(userId);
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);

export const updateLiveChatSender = createAsyncThunk(
  'LiveChatSender/updateLiveChatSender',
  async ({ id, ...data }, thunkAPI) => {
    try {
      return await api.updateLiveChatSender(id, data);
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);

// ✅ Toggle AWS Sender Status
export const toggleAWSSenderStatus = createAsyncThunk(
  'LiveChatSender/toggleAWSSenderStatus',
  async ({ userId, status }, thunkAPI) => {
    try {
      return await api.toggleAWSSenderStatus({ userId, status });
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);
